module.exports = __webpack_public_path__ + "img/weapons.d5dd2c95.webp";